import { random } from "lodash";
import { MOCK_SITE_SAMPLE_IDS } from "./constants";

export const getPlan = async (site) => {
  if (site == MOCK_SITE_SAMPLE_IDS.optimisation_amber) {
    return await getOptimisationAmberSpike();
  }

  if (site == MOCK_SITE_SAMPLE_IDS.optimisation_amber_solar_topup) {
    return await getOptimisationAmberTopup();
  }

  if (site == MOCK_SITE_SAMPLE_IDS.optimisation_tou) {
    return await getOptimisationTou();
  }

  if (site == MOCK_SITE_SAMPLE_IDS.optimisation_tou_solar_topup) {
    return await getOptimisationTouSolarTopUp();
  }

  if (site == MOCK_SITE_SAMPLE_IDS.optimisation_tou_ev) {
    return await getOptimisationTouEv();
  }

  const energy = getData();
  return {
    data: await energy,
    data_next_day: [],
    price_import: 0.33234,
    price_export: -0.24444,
    operation_mode: "min_usage",
    operation_description: "Self-powered",
    operation_information:
      "Your battery is supplementing solar to power your home and minimise electricity " +
      "drawn from the grid during this more expensive period of the day. ",
  };
};

const getOptimisationAmberSpike = async () => {
  const energy = await getEnergyProfile("optimisation_amber");
  return {
    data: await energy,
    data_next_day: [],
    price_import: 13.15,
    price_export: -11.89,
    operation_mode: "discharge",
    operation_description: "Discharging battery",
    operation_information:
      "Electricity prices are high right now, so your battery is discharging to support house loads and " +
      "sell excess energy back to the grid. "
  };
}

const getOptimisationAmberTopup = async () => {
  const energy = await getEnergyProfile("optimisation_amber_solar_topup");
  return {
    data: await energy,
    data_next_day: [],
    price_import: 0.0523842,
    price_export: -0.017832,
    operation_mode: "charge",
    operation_description: "Charging battery",
    operation_information:
      "Your battery is charging up from the grid while prices are low so that energy is available for " +
      "more expensive periods later in the day. "
  };
}

const getOptimisationTou = async () => {
  const energy = await getEnergyProfile("optimisation_tou");
  return {
    data: await energy,
    data_next_day: [],
    price_import: 0.16,
    price_export: -0.05,
    operation_mode: "charge",
    operation_description: "Charging battery",
    operation_information:
      "Your battery is charging up from the grid while prices are low so that energy is available for " +
      "more expensive periods later in the day. "
  };
}

const getOptimisationTouSolarTopUp = async () => {
  const energy = await getEnergyProfile("optimisation_tou_solar_topup");
  return {
    data: await energy,
    data_next_day: [],
    price_import: 0.16,
    price_export: -0.05,
    operation_mode: "charge",
    operation_description: "Charging battery",
    operation_information:
      "Your battery is charging up from the grid while prices are low so that energy is available for " +
      "more expensive periods later in the day. "
  };
}

const getOptimisationTouEv = async () => {
  const energy = await getEnergyProfile("optimisation_tou_ev");
  return {
    data: await energy,
    data_next_day: [],
    price_import: 0.0,
    price_export: -0.05,
    operation_mode: "charge",
    operation_description: "Charging battery",
    operation_information:
      "Your battery is charging up from the grid while prices are low so that energy is available for " +
      "more expensive periods later in the day. "
  };
}


export const getEnergyProfile = async (profile) => {
  const response = await fetch(`/energy/${profile}.json`).then((r) => {
    return r.json();
  });
  // Map items in response and add additional key cost_cumulative using formula:
  // cost_cumulative = price_import * grid_import + price_export * grid_export
  let cost_cumulative = 0;
  const currentDate = new Date();
  const data = response.map(item => {

    const currentDateString = currentDate.toISOString().split("T")[0];
    const updatedTimestamp = `${currentDateString}T${item.timestamp.split("T")[1]
      }`;
    // Assume grid_import is positive grid, grid_export is negative grid
    // convert power to 5min energy
    const grid_import = (item.grid_import ?? 0) / 12.0;
    const grid_export = (item.grid_export ?? 0) / 12.0;
    const price_import = item.price_import ?? 0;
    const price_export = item.price_export ?? 0;
    cost_cumulative += price_import * grid_import + price_export * grid_export;
    return {
      ...item,
      cost_cumulative,
      timestamp: updatedTimestamp
    };
  });
  return data
}

// If we want specific data then just replace return [] with data for each type

export const getData = () => {
  var cost_cumulative = 0;
  return getDayData().map((d) => {
    const currentDate = new Date();
    const currentDateString = currentDate.toISOString().split("T")[0];
    const updatedTimestamp = `${currentDateString}T${d.timestamp.split("T")[1]
      }`;
    const updatedDate = new Date(updatedTimestamp);
    var price_factor = 1.0;
    var demand_window = false;

    const hour = updatedDate.getHours();
    if (hour >= 15 && hour <= 21) {
      demand_window = true;
    }
    if (hour === 7 || hour === 8) {
      price_factor = 2.0;
    } else if (hour == 17) {
      price_factor = 6.0;
    } else if (hour === 13 || hour === 15) {
      price_factor = 0.5;
    } else if (hour >= 18 && hour <= 20) {
      price_factor = 3.0;
    }
    const price_import = 0.14234 * price_factor * random(true);
    const price_export = (price_import - 0.07612) * -1;
    const cost_import = d.grid > 0 ? (price_import * d.grid) / 12 : 0; //KW -> kwh conversion
    const cost_export = d.grid < 0 ? (-1 * (price_export * d.grid)) / 12 : 0;
    cost_cumulative = cost_cumulative + cost_import + cost_export;

    const hotwater = cost_cumulative;

    return {
      timestamp: updatedTimestamp,
      grid: d.grid,
      house: d.house,
      soc: d.soc,
      solar: d.solar,
      price_import,
      price_export,
      demand_window,
      cost_import,
      cost_export,
      cost_cumulative,
      hotwater,
    };
  });
};

const getDayData = () => {
  return [
    {
      battery: 0.0,
      ev: 0.0,
      hotwater: 0.0,
      grid: 0.4021266666666667,
      house: 0.4021266666666667,
      soc: 9.98917,
      solar: 0.0,
      timestamp: "2025-03-26T00:00:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.25575666666666663,
      house: 0.25575666666666663,
      soc: 9.98917,
      solar: 0.0,
      timestamp: "2025-03-26T00:05:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.28981999999999997,
      house: 0.28981999999999997,
      soc: 9.98917,
      solar: 0.0,
      timestamp: "2025-03-26T00:10:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.6871633333333333,
      house: 0.6871633333333333,
      soc: 9.98917,
      solar: 0.0,
      timestamp: "2025-03-26T00:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.37814000000000003,
      house: 0.37814000000000003,
      soc: 9.98917,
      solar: 0.0,
      timestamp: "2025-03-26T00:20:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.43965333333333334,
      house: 0.43965333333333334,
      soc: 9.98917,
      solar: 0.0,
      timestamp: "2025-03-26T00:25:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.28465666666666667,
      house: 0.28465666666666667,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T00:30:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.16112333333333334,
      house: 0.16112333333333334,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T00:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.16097666666666666,
      house: 0.16097666666666666,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T00:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.21468666666666666,
      house: 0.21468666666666666,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T00:45:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.30820666666666663,
      house: 0.30820666666666663,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T00:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.26289999999999997,
      house: 0.26289999999999997,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T00:55:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.27413333333333334,
      house: 0.27413333333333334,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T01:00:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.3164166666666667,
      house: 0.3164166666666667,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T01:05:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.3862833333333333,
      house: 0.3862833333333333,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T01:10:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.19728333333333337,
      house: 0.19728333333333337,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T01:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.16525666666666666,
      house: 0.16525666666666666,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T01:20:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.3765,
      house: 0.3765,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T01:25:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.25926333333333335,
      house: 0.25926333333333335,
      soc: 9.98915,
      solar: 0.0,
      timestamp: "2025-03-26T01:30:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.19347666666666669,
      house: 0.19347666666666669,
      soc: 9.98914,
      solar: 0.0,
      timestamp: "2025-03-26T01:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.23257666666666665,
      house: 0.23257666666666665,
      soc: 9.98914,
      solar: 0.0,
      timestamp: "2025-03-26T01:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.33108,
      house: 0.33108,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T01:45:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.25054333333333334,
      house: 0.25054333333333334,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T01:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.26768333333333333,
      house: 0.26768333333333333,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T01:55:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.32537666666666665,
      house: 0.32537666666666665,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T02:00:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.24682,
      house: 0.24682,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T02:05:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.24956333333333333,
      house: 0.24956333333333333,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T02:10:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.21873333333333334,
      house: 0.21873333333333334,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T02:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.22423666666666664,
      house: 0.22423666666666664,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T02:20:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.19540666666666667,
      house: 0.19540666666666667,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T02:25:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.29613,
      house: 0.29613,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T02:30:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.37344333333333335,
      house: 0.37344333333333335,
      soc: 9.98912,
      solar: 0.0,
      timestamp: "2025-03-26T02:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.21148333333333333,
      house: 0.21148333333333333,
      soc: 9.98911,
      solar: 0.0,
      timestamp: "2025-03-26T02:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.25257,
      house: 0.25257,
      soc: 9.98911,
      solar: 0.0,
      timestamp: "2025-03-26T02:45:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.24553333333333333,
      house: 0.24553333333333333,
      soc: 9.98911,
      solar: 0.0,
      timestamp: "2025-03-26T02:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.25377,
      house: 0.25377,
      soc: 9.98911,
      solar: 0.0,
      timestamp: "2025-03-26T02:55:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.1972066666666667,
      house: 0.1972066666666667,
      soc: 9.98911,
      solar: 0.0,
      timestamp: "2025-03-26T03:00:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.2511966666666667,
      house: 0.2511966666666667,
      soc: 9.98911,
      solar: 0.0,
      timestamp: "2025-03-26T03:05:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.36476,
      house: 0.36476,
      soc: 9.98911,
      solar: 0.0,
      timestamp: "2025-03-26T03:10:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.2529133333333333,
      house: 0.2529133333333333,
      soc: 9.98911,
      solar: 0.0,
      timestamp: "2025-03-26T03:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.2632,
      house: 0.2632,
      soc: 9.98909,
      solar: 0.0,
      timestamp: "2025-03-26T03:20:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.24753333333333333,
      house: 0.24753333333333333,
      soc: 9.98909,
      solar: 0.0,
      timestamp: "2025-03-26T03:25:00+11:00",
    },
    {
      battery: -4.0534300000000005,
      ev: 0.0,
      grid: 4.603666666666666,
      house: 0.5502366666666667,
      soc: 12.2458,
      solar: 0.0,
      timestamp: "2025-03-26T03:30:00+11:00",
    },
    {
      battery: -2.60536,
      ev: 0.0,
      grid: 2.8974966666666666,
      house: 0.29213666666666666,
      soc: 13.6898,
      solar: 0.0,
      timestamp: "2025-03-26T03:35:00+11:00",
    },
    {
      battery: -0.27095,
      ev: 0.0,
      grid: 0.4541533333333333,
      house: 0.18320333333333333,
      soc: 13.8442,
      solar: 0.0,
      timestamp: "2025-03-26T03:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.19857,
      house: 0.19857,
      soc: 13.8442,
      solar: 0.0,
      timestamp: "2025-03-26T03:45:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.33085333333333333,
      house: 0.33085333333333333,
      soc: 13.8442,
      solar: 0.0,
      timestamp: "2025-03-26T03:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.25174,
      house: 0.25174,
      soc: 13.8442,
      solar: 0.0,
      timestamp: "2025-03-26T03:55:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.30514,
      house: 0.30514,
      soc: 13.8442,
      solar: 0.0,
      timestamp: "2025-03-26T04:00:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.29760333333333333,
      house: 0.29760333333333333,
      soc: 13.8442,
      solar: 0.0,
      timestamp: "2025-03-26T04:05:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.30906666666666666,
      house: 0.30906666666666666,
      soc: 13.8442,
      solar: 0.0,
      timestamp: "2025-03-26T04:10:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.16103666666666666,
      house: 0.16103666666666666,
      soc: 13.8442,
      solar: 0.0,
      timestamp: "2025-03-26T04:15:00+11:00",
    },
    {
      battery: -1.8412866666666665,
      ev: 0.0,
      grid: 2.0692166666666667,
      house: 0.22793,
      soc: 14.8609,
      solar: 0.0,
      timestamp: "2025-03-26T04:20:00+11:00",
    },
    {
      battery: -4.255739999999999,
      ev: 0.0,
      grid: 4.626753333333333,
      house: 0.3710133333333333,
      soc: 17.1723,
      solar: 0.0,
      timestamp: "2025-03-26T04:25:00+11:00",
    },
    {
      battery: -1.1858833333333334,
      ev: 0.0,
      grid: 1.63759,
      house: 0.4517066666666667,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T04:30:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.28568666666666664,
      house: 0.28568666666666664,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T04:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.34795,
      house: 0.34795,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T04:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.30015000000000003,
      house: 0.30015000000000003,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T04:45:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.27299,
      house: 0.27299,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T04:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.16370666666666667,
      house: 0.16370666666666667,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T04:55:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.16180666666666665,
      house: 0.16180666666666665,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:00:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.16253666666666666,
      house: 0.16253666666666666,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:05:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.16183999999999998,
      house: 0.16183999999999998,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:10:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.3946733333333333,
      house: 0.3946733333333333,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.3402,
      house: 0.3402,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:20:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.3075866666666667,
      house: 0.3075866666666667,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:25:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.18263333333333334,
      house: 0.18263333333333334,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:30:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.15613666666666665,
      house: 0.15613666666666665,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.28558,
      house: 0.28558,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.20264333333333334,
      house: 0.20264333333333334,
      soc: 17.8288,
      solar: 0.0,
      timestamp: "2025-03-26T05:45:00+11:00",
    },
    {
      battery: -3.3022666666666662,
      ev: 0.0,
      grid: 3.609823333333334,
      house: 0.3075566666666667,
      soc: 19.6231,
      solar: 0.0,
      timestamp: "2025-03-26T05:50:00+11:00",
    },
    {
      battery: -4.6149000000000004,
      ev: 0.0,
      grid: 5.103683333333334,
      house: 0.48878333333333335,
      soc: 22.1291,
      solar: 0.0,
      timestamp: "2025-03-26T05:55:00+11:00",
    },
    {
      battery: -1.018,
      ev: 0.0,
      grid: 1.4393633333333333,
      house: 0.4213633333333333,
      soc: 22.6901,
      solar: 0.0,
      timestamp: "2025-03-26T06:00:00+11:00",
    },
    {
      battery: 0.22201333333333334,
      ev: 0.0,
      grid: 0.06337000000000001,
      house: 0.2853833333333333,
      soc: 22.5679,
      solar: 0.0,
      timestamp: "2025-03-26T06:05:00+11:00",
    },
    {
      battery: 0.26799666666666666,
      ev: 0.0,
      grid: 0.008403333333333332,
      house: 0.2764,
      soc: 22.4201,
      solar: 0.0,
      timestamp: "2025-03-26T06:10:00+11:00",
    },
    {
      battery: 0.20284333333333335,
      ev: 0.0,
      grid: 0.00020333333333333336,
      house: 0.20304666666666668,
      soc: 22.3069,
      solar: 0.0,
      timestamp: "2025-03-26T06:15:00+11:00",
    },
    {
      battery: 0.17751,
      ev: 0.0,
      grid: 0.003143333333333333,
      house: 0.18065333333333333,
      soc: 22.2086,
      solar: 0.0,
      timestamp: "2025-03-26T06:20:00+11:00",
    },
    {
      battery: 0.17503333333333332,
      ev: 0.0,
      grid: 0.00249,
      house: 0.17752333333333334,
      soc: 22.1114,
      solar: 0.0,
      timestamp: "2025-03-26T06:25:00+11:00",
    },
    {
      battery: 0.19238,
      ev: 0.0,
      grid: 0.008806666666666666,
      house: 0.20118666666666665,
      soc: 22.0047,
      solar: 0.0,
      timestamp: "2025-03-26T06:30:00+11:00",
    },
    {
      battery: 0.9147066666666668,
      ev: 0.0,
      grid: 0.003923333333333333,
      house: 0.91863,
      soc: 21.4956,
      solar: 0.0,
      timestamp: "2025-03-26T06:35:00+11:00",
    },
    {
      battery: 0.3798866666666667,
      ev: 0.0,
      grid: -0.0020633333333333337,
      house: 0.37782333333333334,
      soc: 21.2824,
      solar: 0.0,
      timestamp: "2025-03-26T06:40:00+11:00",
    },
    {
      battery: 0.28084666666666663,
      ev: 0.0,
      grid: 0.00097,
      house: 0.28181666666666666,
      soc: 21.1259,
      solar: 0.0,
      timestamp: "2025-03-26T06:45:00+11:00",
    },
    {
      battery: 0.2699566666666667,
      ev: 0.0,
      grid: 0.0019366666666666668,
      house: 0.2718933333333333,
      soc: 20.975,
      solar: 0.0,
      timestamp: "2025-03-26T06:50:00+11:00",
    },
    {
      battery: 0.26943666666666666,
      ev: 0.0,
      grid: 0.0015899999999999998,
      house: 0.2710266666666667,
      soc: 20.8246,
      solar: 0.0,
      timestamp: "2025-03-26T06:55:00+11:00",
    },
    {
      battery: 0.20978333333333335,
      ev: 0.0,
      grid: 0.0012799999999999999,
      house: 0.21106333333333333,
      soc: 20.7072,
      solar: 0.0,
      timestamp: "2025-03-26T07:00:00+11:00",
    },
    {
      battery: 0.21245999999999998,
      ev: 0.0,
      grid: 0.004933333333333333,
      house: 0.21739333333333333,
      soc: 20.5885,
      solar: 0.0,
      timestamp: "2025-03-26T07:05:00+11:00",
    },
    {
      battery: 0.2802766666666667,
      ev: 0.0,
      grid: 0.003906666666666667,
      house: 0.29095333333333334,
      soc: 20.4319,
      solar: 0.00677,
      timestamp: "2025-03-26T07:10:00+11:00",
    },
    {
      battery: 0.2929966666666667,
      ev: 0.0,
      grid: 0.003816666666666667,
      house: 0.3274933333333333,
      soc: 20.2678,
      solar: 0.03068,
      timestamp: "2025-03-26T07:15:00+11:00",
    },
    {
      battery: 0.22924,
      ev: 0.0,
      grid: 0.0005733333333333334,
      house: 0.30240666666666666,
      soc: 20.1396,
      solar: 0.07259333333333333,
      timestamp: "2025-03-26T07:20:00+11:00",
    },
    {
      battery: 0.17339333333333332,
      ev: 0.0,
      grid: 0.007653333333333333,
      house: 0.2962533333333333,
      soc: 20.0427,
      solar: 0.11520666666666665,
      timestamp: "2025-03-26T07:25:00+11:00",
    },
    {
      battery: 0.7249,
      ev: 0.0,
      grid: 0.00782,
      house: 0.8947433333333333,
      soc: 19.6366,
      solar: 0.16202333333333335,
      timestamp: "2025-03-26T07:30:00+11:00",
    },
    {
      battery: 0.69652,
      ev: 0.0,
      grid: 0.00024000000000000003,
      house: 0.9022233333333334,
      soc: 19.2455,
      solar: 0.20546333333333333,
      timestamp: "2025-03-26T07:35:00+11:00",
    },
    {
      battery: 0.6439400000000001,
      ev: 0.0,
      grid: 0.0016733333333333335,
      house: 0.9159966666666667,
      soc: 18.8835,
      solar: 0.2703833333333333,
      timestamp: "2025-03-26T07:40:00+11:00",
    },
    {
      battery: 0.5476466666666667,
      ev: 0.0,
      grid: 0.0018533333333333331,
      house: 0.892,
      soc: 18.5759,
      solar: 0.3425,
      timestamp: "2025-03-26T07:45:00+11:00",
    },
    {
      battery: 0.5182533333333333,
      ev: 0.0,
      grid: 0.006503333333333333,
      house: 0.9357766666666667,
      soc: 18.2854,
      solar: 0.41102,
      timestamp: "2025-03-26T07:50:00+11:00",
    },
    {
      battery: 0.91295,
      ev: 0.0,
      grid: 0.0067466666666666664,
      house: 1.3890633333333333,
      soc: 17.7712,
      solar: 0.4693666666666666,
      timestamp: "2025-03-26T07:55:00+11:00",
    },
    {
      battery: 1.3375966666666668,
      ev: 0.0,
      grid: 0.05379333333333333,
      house: 1.9222433333333333,
      soc: 17.0186,
      solar: 0.5308533333333334,
      timestamp: "2025-03-26T08:00:00+11:00",
    },
    {
      battery: 4.3192466666666665,
      ev: 0.0,
      grid: 0.06148666666666666,
      house: 4.9293933333333335,
      soc: 14.5308,
      solar: 0.54866,
      timestamp: "2025-03-26T08:05:00+11:00",
    },
    {
      battery: 4.409103333333333,
      ev: 2.4,
      grid: 1.0493733333333333,
      house: 6.111166666666666,
      soc: 11.9808,
      solar: 0.65269,
      timestamp: "2025-03-26T08:10:00+11:00",
    },
    {
      battery: 3.4125300000000003,
      ev: 2.4,
      grid: 2.20746,
      house: 6.389376666666666,
      soc: 9.98672,
      solar: 0.7693866666666667,
      timestamp: "2025-03-26T08:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 2.4,
      grid: 5.00362,
      house: 5.856473333333334,
      soc: 9.98672,
      solar: 0.8528533333333334,
      timestamp: "2025-03-26T08:20:00+11:00",
    },
    {
      battery: 0.0,
      ev: 2.4,
      grid: 4.85573,
      house: 5.802576666666667,
      soc: 9.98672,
      solar: 0.9468466666666666,
      timestamp: "2025-03-26T08:25:00+11:00",
    },
    {
      battery: 0.0,
      ev: 2.4,
      grid: 4.360720000000001,
      house: 5.474073333333333,
      soc: 9.98672,
      solar: 1.1133533333333334,
      timestamp: "2025-03-26T08:30:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 3.3170266666666666,
      house: 4.582703333333334,
      soc: 9.98672,
      solar: 1.2656766666666668,
      timestamp: "2025-03-26T08:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 3.2547433333333338,
      house: 4.523759999999999,
      soc: 9.98672,
      solar: 1.2690166666666667,
      timestamp: "2025-03-26T08:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 3.1963066666666666,
      house: 4.501273333333333,
      soc: 9.98672,
      solar: 1.3049666666666666,
      timestamp: "2025-03-26T08:45:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 3.1415833333333336,
      house: 4.503656666666666,
      soc: 9.98672,
      solar: 1.3620733333333335,
      timestamp: "2025-03-26T08:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 3.0724633333333333,
      house: 4.505216666666667,
      soc: 9.98672,
      solar: 1.4327533333333333,
      timestamp: "2025-03-26T08:55:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 2.960046666666667,
      house: 4.51276,
      soc: 9.98672,
      solar: 1.5527133333333332,
      timestamp: "2025-03-26T09:00:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 2.893263333333333,
      house: 4.52305,
      soc: 9.98672,
      solar: 1.6297866666666665,
      timestamp: "2025-03-26T09:05:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 2.949603333333333,
      house: 4.606543333333333,
      soc: 9.98672,
      solar: 1.65694,
      timestamp: "2025-03-26T09:10:00+11:00",
    },
    {
      battery: 0.0,
      ev: 4.2,
      grid: 2.8757266666666665,
      house: 4.607866666666666,
      soc: 9.98672,
      solar: 1.73214,
      timestamp: "2025-03-26T09:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 2.67518,
      house: 4.51999,
      soc: 9.98672,
      solar: 1.84481,
      timestamp: "2025-03-26T09:20:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 2.494766666666667,
      house: 4.456113333333334,
      soc: 9.98672,
      solar: 1.9613466666666668,
      timestamp: "2025-03-26T09:25:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 2.34518,
      house: 4.459956666666667,
      soc: 9.98672,
      solar: 2.1147766666666667,
      timestamp: "2025-03-26T09:30:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 2.206846666666667,
      house: 4.4562100000000004,
      soc: 9.98672,
      solar: 2.2493633333333336,
      timestamp: "2025-03-26T09:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 2.2028333333333334,
      house: 4.472386666666667,
      soc: 9.98672,
      solar: 2.269553333333333,
      timestamp: "2025-03-26T09:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 2.69755,
      house: 4.4869900000000005,
      soc: 9.98672,
      solar: 1.78944,
      timestamp: "2025-03-26T09:45:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 3.1003333333333334,
      house: 4.546906666666667,
      soc: 9.98672,
      solar: 1.4465733333333333,
      timestamp: "2025-03-26T09:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 1.8659233333333334,
      house: 3.3691033333333333,
      soc: 9.98672,
      solar: 1.50318,
      timestamp: "2025-03-26T09:55:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 1.3529166666666668,
      house: 2.9913833333333333,
      soc: 9.98672,
      solar: 1.6384666666666665,
      timestamp: "2025-03-26T10:00:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 1.4917633333333333,
      house: 2.9393000000000002,
      soc: 9.98672,
      solar: 1.4475366666666667,
      timestamp: "2025-03-26T10:05:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 1.6627966666666667,
      house: 2.929806666666667,
      soc: 9.98672,
      solar: 1.26701,
      timestamp: "2025-03-26T10:10:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 1.2933866666666667,
      house: 2.940243333333333,
      soc: 9.98672,
      solar: 1.6468566666666664,
      timestamp: "2025-03-26T10:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 1.3277766666666666,
      house: 2.93071,
      soc: 9.98672,
      solar: 1.602933333333333,
      timestamp: "2025-03-26T10:20:00+11:00",
    },
    {
      battery: 0.0,
      ev: 3.8,
      grid: 1.602666666666667,
      house: 3.0032533333333333,
      soc: 9.98672,
      solar: 1.4005866666666666,
      timestamp: "2025-03-26T10:25:00+11:00",
    },
    {
      battery: -4.024206666666666,
      ev: 3.8,
      grid: 5.826553333333333,
      house: 3.2152266666666662,
      soc: 12.1881,
      solar: 1.41288,
      timestamp: "2025-03-26T10:30:00+11:00",
    },
    {
      battery: -4.990196666666667,
      ev: 3.8,
      grid: 6.708773333333333,
      house: 3.2347300000000003,
      soc: 14.9205,
      solar: 1.5161533333333332,
      timestamp: "2025-03-26T10:35:00+11:00",
    },
    {
      battery: -4.996946666666667,
      ev: 3.8,
      grid: 6.477679999999999,
      house: 3.21214,
      soc: 17.6481,
      solar: 1.7314066666666665,
      timestamp: "2025-03-26T10:40:00+11:00",
    },
    {
      battery: -4.9966333333333335,
      ev: 3.8,
      grid: 5.85379,
      house: 3.135176666666667,
      soc: 20.3647,
      solar: 2.27802,
      timestamp: "2025-03-26T10:45:00+11:00",
    },
    {
      battery: -4.998423333333333,
      ev: 3.8,
      grid: 5.6716299999999995,
      house: 3.12193,
      soc: 23.0705,
      solar: 2.448723333333333,
      timestamp: "2025-03-26T10:50:00+11:00",
    },
    {
      battery: -4.998286666666667,
      ev: 3.8,
      grid: 5.40352,
      house: 3.1106700000000003,
      soc: 25.769,
      solar: 2.7054366666666665,
      timestamp: "2025-03-26T10:55:00+11:00",
    },
    {
      battery: -4.99653,
      ev: 3.8,
      grid: 4.9823200000000005,
      house: 3.1035899999999996,
      soc: 28.4607,
      solar: 3.1178,
      timestamp: "2025-03-26T11:00:00+11:00",
    },
    {
      battery: -4.997323333333333,
      ev: 3.8,
      grid: 4.5953800000000005,
      house: 3.195866666666667,
      soc: 31.1473,
      solar: 3.59781,
      timestamp: "2025-03-26T11:05:00+11:00",
    },
    {
      battery: -4.998396666666666,
      ev: 3.8,
      grid: 3.4562066666666666,
      house: 3.2078999999999995,
      soc: 33.8316,
      solar: 4.75009,
      timestamp: "2025-03-26T11:10:00+11:00",
    },
    {
      battery: -4.996316666666667,
      ev: 3.8,
      grid: 3.1965833333333338,
      house: 3.2087166666666667,
      soc: 36.5149,
      solar: 5.00845,
      timestamp: "2025-03-26T11:15:00+11:00",
    },
    {
      battery: -4.996533333333334,
      ev: 3.8,
      grid: 4.266683333333334,
      house: 3.197163333333333,
      soc: 39.1979,
      solar: 3.927013333333333,
      timestamp: "2025-03-26T11:20:00+11:00",
    },
    {
      battery: -4.998096666666666,
      ev: 3.8,
      grid: 4.324323333333334,
      house: 3.1350966666666666,
      soc: 41.881,
      solar: 3.8088699999999998,
      timestamp: "2025-03-26T11:25:00+11:00",
    },
    {
      battery: -1.72705,
      ev: 3.8,
      grid: 0.58669,
      house: 3.0758533333333333,
      soc: 42.8206,
      solar: 4.216213333333333,
      timestamp: "2025-03-26T11:30:00+11:00",
    },
    {
      battery: -4.696926666666666,
      ev: 3.8,
      grid: 2.1166533333333333,
      house: 3.126343333333333,
      soc: 45.337,
      solar: 5.706616666666666,
      timestamp: "2025-03-26T11:35:00+11:00",
    },
    {
      battery: -2.0619633333333334,
      ev: 2.4,
      grid: 0.29553999999999997,
      house: 3.1060533333333336,
      soc: 46.4599,
      solar: 4.872476666666667,
      timestamp: "2025-03-26T11:40:00+11:00",
    },
    {
      battery: -0.14724666666666666,
      ev: 2.4,
      grid: 0.23422666666666664,
      house: 3.0836133333333335,
      soc: 46.5412,
      solar: 2.9966333333333335,
      timestamp: "2025-03-26T11:45:00+11:00",
    },
    {
      battery: -4.46132,
      ev: 2.4,
      grid: 5.39484,
      house: 3.1817699999999998,
      soc: 48.9241,
      solar: 2.2482499999999996,
      timestamp: "2025-03-26T11:50:00+11:00",
    },
    {
      battery: -4.996993333333333,
      ev: 2.4,
      grid: 5.693806666666666,
      house: 3.2237400000000003,
      soc: 51.604,
      solar: 2.5269266666666668,
      timestamp: "2025-03-26T11:55:00+11:00",
    },
    {
      battery: -4.997646666666666,
      ev: 2.4,
      grid: 4.80994,
      house: 3.2221366666666666,
      soc: 54.2823,
      solar: 3.409843333333333,
      timestamp: "2025-03-26T12:00:00+11:00",
    },
    {
      battery: -4.99648,
      ev: 2.4,
      grid: 4.563046666666667,
      house: 3.220276666666667,
      soc: 56.9582,
      solar: 3.6537100000000002,
      timestamp: "2025-03-26T12:05:00+11:00",
    },
    {
      battery: -4.99921,
      ev: 2.4,
      grid: 3.8847866666666664,
      house: 3.00572,
      soc: 59.6348,
      solar: 4.120143333333333,
      timestamp: "2025-03-26T12:10:00+11:00",
    },
    {
      battery: -5.00003,
      ev: 2.4,
      grid: 2.5865333333333336,
      house: 2.9359433333333333,
      soc: 62.3082,
      solar: 5.3494399999999995,
      timestamp: "2025-03-26T12:15:00+11:00",
    },
    {
      battery: -4.383443333333333,
      ev: 2.4,
      grid: 0.08985333333333334,
      house: 2.97983,
      soc: 64.656,
      solar: 7.27342,
      timestamp: "2025-03-26T12:20:00+11:00",
    },
    {
      battery: -3.41094,
      ev: 2.4,
      grid: 0.04789333333333333,
      house: 2.8114033333333337,
      soc: 66.4837,
      solar: 6.17445,
      timestamp: "2025-03-26T12:25:00+11:00",
    },
    {
      battery: -4.202553333333333,
      ev: 2.4,
      grid: 0.00258,
      house: 2.6950666666666665,
      soc: 68.7313,
      solar: 6.89504,
      timestamp: "2025-03-26T12:30:00+11:00",
    },
    {
      battery: -4.11659,
      ev: 2.4,
      grid: 0.0028033333333333335,
      house: 2.66159,
      soc: 70.9298,
      solar: 6.775376666666666,
      timestamp: "2025-03-26T12:35:00+11:00",
    },
    {
      battery: -3.2399299999999998,
      ev: 2.4,
      grid: 0.01846,
      house: 2.5091466666666666,
      soc: 72.6667,
      solar: 5.730616666666666,
      timestamp: "2025-03-26T12:40:00+11:00",
    },
    {
      battery: -3.599193333333333,
      ev: 2.4,
      grid: -0.021483333333333333,
      house: 2.5440899999999997,
      soc: 74.5851,
      solar: 6.164766666666667,
      timestamp: "2025-03-26T12:45:00+11:00",
    },
    {
      battery: -2.9974533333333335,
      ev: 2.4,
      grid: 0.027346666666666665,
      house: 2.57514,
      soc: 76.1906,
      solar: 5.545246666666666,
      timestamp: "2025-03-26T12:50:00+11:00",
    },
    {
      battery: -2.95771,
      ev: 2.4,
      grid: -0.0149,
      house: 2.1212833333333334,
      soc: 77.7719,
      solar: 5.093893333333333,
      timestamp: "2025-03-26T12:55:00+11:00",
    },
    {
      battery: -4.874023333333334,
      ev: 2.8,
      grid: 0.34681666666666666,
      house: 1.4172133333333334,
      soc: 80.358,
      solar: 5.94442,
      timestamp: "2025-03-26T13:00:00+11:00",
    },
    {
      battery: -1.2275366666666665,
      ev: 2.8,
      grid: 0.5800066666666667,
      house: 3.1100233333333334,
      soc: 81.0194,
      solar: 3.7575533333333335,
      timestamp: "2025-03-26T13:05:00+11:00",
    },
    {
      battery: -4.561266666666667,
      ev: 2.8,
      grid: 2.60635,
      house: 3.126223333333334,
      soc: 83.4342,
      solar: 5.08114,
      timestamp: "2025-03-26T13:10:00+11:00",
    },
    {
      battery: -4.997293333333333,
      ev: 2.8,
      grid: 1.4550366666666668,
      house: 3.1090599999999995,
      soc: 86.0859,
      solar: 6.651316666666666,
      timestamp: "2025-03-26T13:15:00+11:00",
    },
    {
      battery: -3.8039766666666663,
      ev: 2.8,
      grid: 0.16896,
      house: 3.07239,
      soc: 88.1138,
      solar: 6.707406666666666,
      timestamp: "2025-03-26T13:20:00+11:00",
    },
    {
      battery: -3.271316666666667,
      ev: 0.0,
      grid: 0.00033,
      house: 3.044063333333334,
      soc: 89.8604,
      solar: 6.31505,
      timestamp: "2025-03-26T13:25:00+11:00",
    },
    {
      battery: -3.7237066666666667,
      ev: 0.0,
      grid: -0.01919,
      house: 2.665566666666667,
      soc: 91.8413,
      solar: 6.408463333333333,
      timestamp: "2025-03-26T13:30:00+11:00",
    },
    {
      battery: -4.395473333333333,
      ev: 0.0,
      grid: -0.0012866666666666666,
      house: 1.7417566666666668,
      soc: 94.1755,
      solar: 6.138516666666667,
      timestamp: "2025-03-26T13:35:00+11:00",
    },
    {
      battery: -4.390773333333334,
      ev: 0.0,
      grid: -8.666666666666667e-5,
      house: 1.8847899999999997,
      soc: 96.5031,
      solar: 6.275650000000001,
      timestamp: "2025-03-26T13:40:00+11:00",
    },
    {
      battery: -4.308623333333333,
      ev: 0.0,
      grid: 0.0041533333333333335,
      house: 1.8981033333333335,
      soc: 98.7832,
      solar: 6.2025733333333335,
      timestamp: "2025-03-26T13:45:00+11:00",
    },
    {
      battery: -1.9742933333333332,
      ev: 0.0,
      grid: -1.7052,
      house: 1.7871766666666664,
      soc: 99.841,
      solar: 5.46667,
      timestamp: "2025-03-26T13:50:00+11:00",
    },
    {
      battery: -0.4807,
      ev: 0.0,
      grid: -0.13297666666666666,
      house: 1.757893333333333,
      soc: 100.0,
      solar: 2.37157,
      timestamp: "2025-03-26T13:55:00+11:00",
    },
    {
      battery: -0.4799833333333333,
      ev: 0.0,
      grid: 0.3417966666666667,
      house: 1.6052166666666665,
      soc: 100.0,
      solar: 1.7434033333333332,
      timestamp: "2025-03-26T14:00:00+11:00",
    },
    {
      battery: -0.48069000000000006,
      ev: 0.0,
      grid: -1.1961066666666667,
      house: 1.7324133333333336,
      soc: 100.0,
      solar: 3.4092100000000003,
      timestamp: "2025-03-26T14:05:00+11:00",
    },
    {
      battery: -0.4810433333333334,
      ev: 0.0,
      grid: 0.5038733333333334,
      house: 1.5686166666666665,
      soc: 100.0,
      solar: 1.5457866666666664,
      timestamp: "2025-03-26T14:10:00+11:00",
    },
    {
      battery: 0.11533333333333334,
      ev: 0.0,
      grid: 0.17159666666666668,
      house: 1.6069200000000001,
      soc: 99.9038,
      solar: 1.31999,
      timestamp: "2025-03-26T14:15:00+11:00",
    },
    {
      battery: 0.22202,
      ev: 0.0,
      grid: 0.11061666666666667,
      house: 1.6691333333333334,
      soc: 99.7819,
      solar: 1.3364966666666667,
      timestamp: "2025-03-26T14:20:00+11:00",
    },
    {
      battery: 0.02528333333333333,
      ev: 0.0,
      grid: 0.18729,
      house: 1.6825433333333333,
      soc: 99.7653,
      solar: 1.46997,
      timestamp: "2025-03-26T14:25:00+11:00",
    },
    {
      battery: -0.01038,
      ev: 0.0,
      grid: 0.4692233333333333,
      house: 1.6552833333333334,
      soc: 99.771,
      solar: 1.19644,
      timestamp: "2025-03-26T14:30:00+11:00",
    },
    {
      battery: 0.47797666666666666,
      ev: 0.0,
      grid: 0.16607333333333332,
      house: 1.83202,
      soc: 99.7612,
      solar: 1.18797,
      timestamp: "2025-03-26T14:35:00+11:00",
    },
    {
      battery: 0.04724,
      ev: 0.0,
      grid: 0.5584233333333334,
      house: 2.5333533333333333,
      soc: 99.7365,
      solar: 1.9276900000000001,
      timestamp: "2025-03-26T14:40:00+11:00",
    },
    {
      battery: -0.00439,
      ev: 0.0,
      grid: 0.5414166666666667,
      house: 2.6195833333333334,
      soc: 99.7389,
      solar: 2.0825566666666666,
      timestamp: "2025-03-26T14:45:00+11:00",
    },
    {
      battery: -0.06840333333333334,
      ev: 0.0,
      grid: 0.4168766666666667,
      house: 2.6358266666666665,
      soc: 99.7762,
      solar: 2.2873533333333333,
      timestamp: "2025-03-26T14:50:00+11:00",
    },
    {
      battery: -0.03704333333333333,
      ev: 0.0,
      grid: 0.4335466666666667,
      house: 2.734636666666667,
      soc: 99.7962,
      solar: 2.3381333333333334,
      timestamp: "2025-03-26T14:55:00+11:00",
    },
    {
      battery: -0.3130466666666667,
      ev: 0.0,
      grid: -0.10657,
      house: 2.77751,
      soc: 99.9647,
      solar: 3.1971266666666667,
      timestamp: "2025-03-26T15:00:00+11:00",
    },
    {
      battery: -0.4761833333333333,
      ev: 0.0,
      grid: -0.35207666666666665,
      house: 2.6728766666666663,
      soc: 100.0,
      solar: 3.5011366666666666,
      timestamp: "2025-03-26T15:05:00+11:00",
    },
    {
      battery: -0.29181666666666667,
      ev: 0.0,
      grid: -0.06275,
      house: 2.678506666666667,
      soc: 100.0,
      solar: 3.0330733333333333,
      timestamp: "2025-03-26T15:10:00+11:00",
    },
    {
      battery: -0.06375666666666666,
      ev: 0.0,
      grid: 1.7141600000000001,
      house: 4.41205,
      soc: 100.0,
      solar: 2.7616466666666666,
      timestamp: "2025-03-26T15:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 1.7909933333333332,
      house: 4.31715,
      soc: 100.0,
      solar: 2.5261566666666666,
      timestamp: "2025-03-26T15:20:00+11:00",
    },
    {
      battery: -0.18457666666666667,
      ev: 0.0,
      grid: 0.4378766666666667,
      house: 2.70594,
      soc: 100.0,
      solar: 2.4526399999999997,
      timestamp: "2025-03-26T15:25:00+11:00",
    },
    {
      battery: -0.4822333333333333,
      ev: 0.0,
      grid: -0.5246433333333334,
      house: 1.45689,
      soc: 100.0,
      solar: 2.4637666666666664,
      timestamp: "2025-03-26T15:30:00+11:00",
    },
    {
      battery: -0.3550333333333333,
      ev: 0.0,
      grid: -0.25404333333333334,
      house: 2.1854466666666665,
      soc: 100.0,
      solar: 2.7945233333333332,
      timestamp: "2025-03-26T15:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 1.0325333333333333,
      house: 3.6741366666666666,
      soc: 100.0,
      solar: 2.6416033333333333,
      timestamp: "2025-03-26T15:40:00+11:00",
    },
    {
      battery: -0.4673,
      ev: 0.0,
      grid: -0.45388,
      house: 1.5631666666666668,
      soc: 100.0,
      solar: 2.4843466666666667,
      timestamp: "2025-03-26T15:45:00+11:00",
    },
    {
      battery: -0.19449666666666665,
      ev: 0.0,
      grid: -0.64393,
      house: 1.6235666666666668,
      soc: 100.0,
      solar: 2.461993333333333,
      timestamp: "2025-03-26T15:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.6405266666666667,
      house: 2.6865966666666665,
      soc: 100.0,
      solar: 2.04607,
      timestamp: "2025-03-26T15:55:00+11:00",
    },
    {
      battery: 0.6673233333333334,
      ev: 0.0,
      grid: 0.07547666666666666,
      house: 2.608773333333333,
      soc: 99.6376,
      solar: 1.8659733333333335,
      timestamp: "2025-03-26T16:00:00+11:00",
    },
    {
      battery: 1.5349533333333332,
      ev: 0.0,
      grid: 0.021456666666666666,
      house: 3.4491533333333333,
      soc: 98.8014,
      solar: 1.8927433333333332,
      timestamp: "2025-03-26T16:05:00+11:00",
    },
    {
      battery: 0.5145500000000001,
      ev: 0.0,
      grid: -0.20101333333333335,
      house: 2.1330533333333332,
      soc: 98.5202,
      solar: 1.8195166666666664,
      timestamp: "2025-03-26T16:10:00+11:00",
    },
    {
      battery: 0.3076333333333333,
      ev: 0.0,
      grid: 0.20657333333333333,
      house: 2.18032,
      soc: 98.3484,
      solar: 1.6661133333333336,
      timestamp: "2025-03-26T16:15:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.05324999999999999,
      house: 1.3375066666666666,
      soc: 98.3484,
      solar: 1.2842566666666666,
      timestamp: "2025-03-26T16:20:00+11:00",
    },
    {
      battery: 0.35339333333333334,
      ev: 0.0,
      grid: 0.03472666666666667,
      house: 1.23572,
      soc: 98.1571,
      solar: 0.8476000000000001,
      timestamp: "2025-03-26T16:25:00+11:00",
    },
    {
      battery: 0.6316033333333333,
      ev: 0.0,
      grid: 0.0077933333333333335,
      house: 1.2261833333333334,
      soc: 97.8127,
      solar: 0.5867866666666667,
      timestamp: "2025-03-26T16:30:00+11:00",
    },
    {
      battery: 0.5444666666666667,
      ev: 0.0,
      grid: 0.00098,
      house: 1.2291633333333332,
      soc: 97.5155,
      solar: 0.6837166666666666,
      timestamp: "2025-03-26T16:35:00+11:00",
    },
    {
      battery: 0.6070866666666667,
      ev: 0.0,
      grid: 0.0035633333333333333,
      house: 1.2226366666666666,
      soc: 97.185,
      solar: 0.6119866666666667,
      timestamp: "2025-03-26T16:40:00+11:00",
    },
    {
      battery: 0.7626066666666667,
      ev: 0.0,
      grid: 0.0034033333333333333,
      house: 1.2343733333333333,
      soc: 96.7693,
      solar: 0.4683633333333333,
      timestamp: "2025-03-26T16:45:00+11:00",
    },
    {
      battery: 0.9299266666666667,
      ev: 0.0,
      grid: 0.004236666666666666,
      house: 1.42163,
      soc: 96.2621,
      solar: 0.4874666666666666,
      timestamp: "2025-03-26T16:50:00+11:00",
    },
    {
      battery: 1.0654366666666666,
      ev: 0.0,
      grid: 0.00396,
      house: 1.4993400000000001,
      soc: 95.68,
      solar: 0.42994333333333334,
      timestamp: "2025-03-26T16:55:00+11:00",
    },
    {
      battery: 1.0535933333333334,
      ev: 0.0,
      grid: -0.00013000000000000002,
      house: 1.4959133333333334,
      soc: 95.1046,
      solar: 0.44245,
      timestamp: "2025-03-26T17:00:00+11:00",
    },
    {
      battery: 0.9422600000000001,
      ev: 0.0,
      grid: 0.0016233333333333334,
      house: 1.4088733333333334,
      soc: 94.5904,
      solar: 0.46499,
      timestamp: "2025-03-26T17:05:00+11:00",
    },
    {
      battery: 0.8558100000000001,
      ev: 0.0,
      grid: -0.0012833333333333334,
      house: 1.2623199999999999,
      soc: 94.123,
      solar: 0.40779333333333334,
      timestamp: "2025-03-26T17:10:00+11:00",
    },
    {
      battery: 0.7513766666666667,
      ev: 0.0,
      grid: 0.00894,
      house: 1.17695,
      soc: 93.7134,
      solar: 0.4166333333333333,
      timestamp: "2025-03-26T17:15:00+11:00",
    },
    {
      battery: 0.87776,
      ev: 0.0,
      grid: 0.004753333333333333,
      house: 1.2145299999999999,
      soc: 93.2351,
      solar: 0.3320166666666667,
      timestamp: "2025-03-26T17:20:00+11:00",
    },
    {
      battery: 0.83707,
      ev: 0.0,
      grid: 4.3333333333333334e-5,
      house: 1.1452900000000001,
      soc: 92.7782,
      solar: 0.30817666666666665,
      timestamp: "2025-03-26T17:25:00+11:00",
    },
    {
      battery: 0.9093266666666666,
      ev: 0.0,
      grid: 0.0067933333333333335,
      house: 1.20179,
      soc: 92.282,
      solar: 0.28567,
      timestamp: "2025-03-26T17:30:00+11:00",
    },
    {
      battery: 0.96208,
      ev: 0.0,
      grid: 0.00315,
      house: 1.1964299999999999,
      soc: 91.7569,
      solar: 0.23120000000000002,
      timestamp: "2025-03-26T17:35:00+11:00",
    },
    {
      battery: 0.9033966666666667,
      ev: 0.0,
      grid: -0.003306666666666667,
      house: 1.0577466666666666,
      soc: 91.2635,
      solar: 0.15765666666666667,
      timestamp: "2025-03-26T17:40:00+11:00",
    },
    {
      battery: 0.6296266666666667,
      ev: 0.0,
      grid: 0.00027333333333333333,
      house: 0.8525966666666667,
      soc: 90.9194,
      solar: 0.22269666666666668,
      timestamp: "2025-03-26T17:45:00+11:00",
    },
    {
      battery: 2.0223266666666664,
      ev: 0.0,
      grid: 0.02400666666666667,
      house: 2.3937933333333334,
      soc: 89.8139,
      solar: 0.34746,
      timestamp: "2025-03-26T17:50:00+11:00",
    },
    {
      battery: 1.0882399999999999,
      ev: 0.0,
      grid: -0.025586666666666667,
      house: 1.4383066666666666,
      soc: 89.2149,
      solar: 0.3756533333333334,
      timestamp: "2025-03-26T17:55:00+11:00",
    },
    {
      battery: 0.34642666666666666,
      ev: 0.0,
      grid: -2.03,
      house: 0.7351933333333334,
      soc: 89.0265,
      solar: 0.38149,
      timestamp: "2025-03-26T18:00:00+11:00",
    },
    {
      battery: 0.6765633333333334,
      ev: 0.0,
      grid: -2.03,
      house: 0.8898499999999999,
      soc: 88.6586,
      solar: 0.20106333333333334,
      timestamp: "2025-03-26T18:05:00+11:00",
    },
    {
      battery: 0.8008566666666666,
      ev: 0.0,
      grid: -2.03,
      house: 0.9762200000000001,
      soc: 88.2214,
      solar: 0.16186333333333333,
      timestamp: "2025-03-26T18:10:00+11:00",
    },
    {
      battery: 1.0412033333333333,
      ev: 0.0,
      grid: -2.03,
      house: 1.2409033333333335,
      soc: 87.6532,
      solar: 0.19308,
      timestamp: "2025-03-26T18:15:00+11:00",
    },
    {
      battery: 1.0144099999999998,
      ev: 0.0,
      grid: -2.03,
      house: 1.20936,
      soc: 87.0992,
      solar: 0.18624333333333332,
      timestamp: "2025-03-26T18:20:00+11:00",
    },
    {
      battery: 2.372986666666667,
      ev: 0.0,
      grid: -2.03,
      house: 2.5691,
      soc: 85.7984,
      solar: 0.16734000000000002,
      timestamp: "2025-03-26T18:25:00+11:00",
    },
    {
      battery: 4.1450233333333335,
      ev: 0.0,
      grid: -2.03,
      house: 4.61418,
      soc: 83.5094,
      solar: 0.12749666666666667,
      timestamp: "2025-03-26T18:30:00+11:00",
    },
    {
      battery: 1.9938633333333333,
      ev: 0.0,
      grid: -2.03,
      house: 2.03371,
      soc: 82.4108,
      solar: 0.07674333333333333,
      timestamp: "2025-03-26T18:35:00+11:00",
    },
    {
      battery: 2.0214766666666666,
      ev: 0.0,
      grid: -2.03,
      house: 2.0471500000000002,
      soc: 81.3018,
      solar: 0.04237333333333333,
      timestamp: "2025-03-26T18:40:00+11:00",
    },
    {
      battery: 1.4952766666666668,
      ev: 0.0,
      grid: -2.03,
      house: 1.50969,
      soc: 80.4831,
      solar: 0.01816,
      timestamp: "2025-03-26T18:45:00+11:00",
    },
    {
      battery: 1.8887066666666665,
      ev: 0.0,
      grid: -2.03,
      house: 1.9078833333333334,
      soc: 79.4475,
      solar: 0.0,
      timestamp: "2025-03-26T18:50:00+11:00",
    },
    {
      battery: 2.85677,
      ev: 0.0,
      grid: -2.03,
      house: 2.9810133333333333,
      soc: 77.8729,
      solar: 0.0,
      timestamp: "2025-03-26T18:55:00+11:00",
    },
    {
      battery: 1.4397133333333334,
      ev: 0.0,
      grid: -2.03,
      house: 1.4439666666666666,
      soc: 77.0841,
      solar: 0.0,
      timestamp: "2025-03-26T19:00:00+11:00",
    },
    {
      battery: 1.8350933333333335,
      ev: 0.0,
      grid: -2.03,
      house: 1.8823033333333332,
      soc: 76.0756,
      solar: 0.0,
      timestamp: "2025-03-26T19:05:00+11:00",
    },
    {
      battery: 1.2388366666666668,
      ev: 0.0,
      grid: -2.03,
      house: 1.2669666666666666,
      soc: 75.3966,
      solar: 0.0,
      timestamp: "2025-03-26T19:10:00+11:00",
    },
    {
      battery: 0.91478,
      ev: 0.0,
      grid: -2.03,
      house: 0.9167933333333333,
      soc: 74.8967,
      solar: 0.0,
      timestamp: "2025-03-26T19:15:00+11:00",
    },
    {
      battery: 0.94505,
      ev: 0.0,
      grid: -2.03,
      house: 0.9472166666666667,
      soc: 74.3798,
      solar: 0.0,
      timestamp: "2025-03-26T19:20:00+11:00",
    },
    {
      battery: 1.0504266666666666,
      ev: 0.0,
      grid: -2.03,
      house: 1.0538933333333333,
      soc: 73.8054,
      solar: 0.0,
      timestamp: "2025-03-26T19:25:00+11:00",
    },
    {
      battery: 1.3284099999999999,
      ev: 0.0,
      grid: -2.03,
      house: 1.3401966666666665,
      soc: 73.0787,
      solar: 0.0,
      timestamp: "2025-03-26T19:30:00+11:00",
    },
    {
      battery: 1.4467599999999998,
      ev: 0.0,
      grid: -2.03,
      house: 1.4518133333333334,
      soc: 72.2856,
      solar: 0.0,
      timestamp: "2025-03-26T19:35:00+11:00",
    },
    {
      battery: 1.3458133333333333,
      ev: 0.0,
      grid: -2.03,
      house: 1.3577466666666667,
      soc: 71.5475,
      solar: 0.0,
      timestamp: "2025-03-26T19:40:00+11:00",
    },
    {
      battery: 1.5723333333333334,
      ev: 0.0,
      grid: -2.03,
      house: 1.5775000000000001,
      soc: 70.6833,
      solar: 0.0,
      timestamp: "2025-03-26T19:45:00+11:00",
    },
    {
      battery: 1.7590766666666666,
      ev: 0.0,
      grid: 0.00411,
      house: 1.7631866666666665,
      soc: 69.7153,
      solar: 0.0,
      timestamp: "2025-03-26T19:50:00+11:00",
    },
    {
      battery: 1.7668266666666668,
      ev: 0.0,
      grid: 0.0031233333333333334,
      house: 1.76995,
      soc: 68.7405,
      solar: 0.0,
      timestamp: "2025-03-26T19:55:00+11:00",
    },
    {
      battery: 1.24641,
      ev: 0.0,
      grid: 0.00021666666666666666,
      house: 1.2466266666666665,
      soc: 68.0538,
      solar: 0.0,
      timestamp: "2025-03-26T20:00:00+11:00",
    },
    {
      battery: 1.2001666666666666,
      ev: 0.0,
      grid: 0.0007099999999999999,
      house: 1.2008766666666666,
      soc: 67.3924,
      solar: 0.0,
      timestamp: "2025-03-26T20:05:00+11:00",
    },
    {
      battery: 1.20346,
      ev: 0.0,
      grid: -0.00012666666666666666,
      house: 1.2033333333333331,
      soc: 66.7299,
      solar: 0.0,
      timestamp: "2025-03-26T20:10:00+11:00",
    },
    {
      battery: 1.1224966666666667,
      ev: 0.0,
      grid: 0.0015666666666666667,
      house: 1.1240633333333334,
      soc: 66.1117,
      solar: 0.0,
      timestamp: "2025-03-26T20:15:00+11:00",
    },
    {
      battery: 1.0225833333333334,
      ev: 0.0,
      grid: -0.001966666666666667,
      house: 1.0206166666666667,
      soc: 65.5482,
      solar: 0.0,
      timestamp: "2025-03-26T20:20:00+11:00",
    },
    {
      battery: 1.673293333333333,
      ev: 0.0,
      grid: 0.03022666666666667,
      house: 1.7035200000000001,
      soc: 64.6259,
      solar: 0.0,
      timestamp: "2025-03-26T20:25:00+11:00",
    },
    {
      battery: 1.0446533333333334,
      ev: 0.0,
      grid: -0.012506666666666666,
      house: 1.0321466666666668,
      soc: 64.0454,
      solar: 0.0,
      timestamp: "2025-03-26T20:30:00+11:00",
    },
    {
      battery: 1.0203133333333332,
      ev: 0.0,
      grid: -2.3333333333333332e-5,
      house: 1.02029,
      soc: 63.482,
      solar: 0.0,
      timestamp: "2025-03-26T20:35:00+11:00",
    },
    {
      battery: 1.25006,
      ev: 0.0,
      grid: 0.02255666666666667,
      house: 1.2726166666666667,
      soc: 62.7913,
      solar: 0.0,
      timestamp: "2025-03-26T20:40:00+11:00",
    },
    {
      battery: 1.1931733333333332,
      ev: 0.0,
      grid: 0.0046166666666666665,
      house: 1.1977900000000001,
      soc: 62.1325,
      solar: 0.0,
      timestamp: "2025-03-26T20:45:00+11:00",
    },
    {
      battery: 1.1881066666666666,
      ev: 0.0,
      grid: 0.0032933333333333334,
      house: 1.1914,
      soc: 61.4766,
      solar: 0.0,
      timestamp: "2025-03-26T20:50:00+11:00",
    },
    {
      battery: 1.1022566666666667,
      ev: 0.0,
      grid: 0.0036633333333333335,
      house: 1.10592,
      soc: 60.8678,
      solar: 0.0,
      timestamp: "2025-03-26T20:55:00+11:00",
    },
    {
      battery: 0.12866,
      ev: 0.0,
      grid: 0.91534,
      house: 1.044,
      soc: 60.7948,
      solar: 0.0,
      timestamp: "2025-03-26T21:00:00+11:00",
    },
    {
      battery: 0.79673,
      ev: 0.0,
      grid: 0.11648333333333334,
      house: 0.9132133333333332,
      soc: 60.3569,
      solar: 0.0,
      timestamp: "2025-03-26T21:05:00+11:00",
    },
    {
      battery: 0.7896466666666666,
      ev: 0.0,
      grid: 0.0013,
      house: 0.7909466666666667,
      soc: 59.9206,
      solar: 0.0,
      timestamp: "2025-03-26T21:10:00+11:00",
    },
    {
      battery: 0.6449699999999999,
      ev: 0.0,
      grid: 0.0011366666666666667,
      house: 0.6461066666666666,
      soc: 59.5643,
      solar: 0.0,
      timestamp: "2025-03-26T21:15:00+11:00",
    },
    {
      battery: 0.75044,
      ev: 0.0,
      grid: 0.0109,
      house: 0.76134,
      soc: 59.1502,
      solar: 0.0,
      timestamp: "2025-03-26T21:20:00+11:00",
    },
    {
      battery: 0.79864,
      ev: 0.0,
      grid: 0.0010333333333333332,
      house: 0.7996733333333333,
      soc: 58.7085,
      solar: 0.0,
      timestamp: "2025-03-26T21:25:00+11:00",
    },
    {
      battery: 0.08104333333333333,
      ev: 0.0,
      grid: 0.5153466666666666,
      house: 0.59639,
      soc: 58.6622,
      solar: 0.0,
      timestamp: "2025-03-26T21:30:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.4761666666666666,
      house: 0.4761666666666666,
      soc: 58.6622,
      solar: 0.0,
      timestamp: "2025-03-26T21:35:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.53094,
      house: 0.53094,
      soc: 58.6622,
      solar: 0.0,
      timestamp: "2025-03-26T21:40:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.5660233333333333,
      house: 0.5660233333333333,
      soc: 58.6622,
      solar: 0.0,
      timestamp: "2025-03-26T21:45:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.57386,
      house: 0.57386,
      soc: 58.6622,
      solar: 0.0,
      timestamp: "2025-03-26T21:50:00+11:00",
    },
    {
      battery: 0.0,
      ev: 0.0,
      grid: 0.4098733333333333,
      house: 0.4098733333333333,
      soc: 58.6622,
      solar: 0.0,
      timestamp: "2025-03-26T21:55:00+11:00",
    },
    {
      battery: 0.5152733333333334,
      ev: 0.0,
      grid: 0.05909666666666666,
      house: 0.57437,
      soc: 58.3792,
      solar: 0.0,
      timestamp: "2025-03-26T22:00:00+11:00",
    },
    {
      battery: 0.5221233333333334,
      ev: 0.0,
      grid: 0.00014,
      house: 0.5222633333333333,
      soc: 58.0908,
      solar: 0.0,
      timestamp: "2025-03-26T22:05:00+11:00",
    },
    {
      battery: 0.4023,
      ev: 0.0,
      grid: 0.0024333333333333334,
      house: 0.4047333333333334,
      soc: 57.8684,
      solar: 0.0,
      timestamp: "2025-03-26T22:10:00+11:00",
    },
    {
      battery: 0.52136,
      ev: 0.0,
      grid: -0.012976666666666668,
      house: 0.5083833333333334,
      soc: 57.5809,
      solar: 0.0,
      timestamp: "2025-03-26T22:15:00+11:00",
    },
    {
      battery: 0.6424133333333334,
      ev: 0.0,
      grid: 0.0013533333333333333,
      house: 0.6437666666666666,
      soc: 57.2254,
      solar: 0.0,
      timestamp: "2025-03-26T22:20:00+11:00",
    },
    {
      battery: 0.5084366666666666,
      ev: 0.0,
      grid: 0.00117,
      house: 0.5096066666666668,
      soc: 56.9444,
      solar: 0.0,
      timestamp: "2025-03-26T22:25:00+11:00",
    },
    {
      battery: 0.5043300000000001,
      ev: 0.0,
      grid: 0.0023466666666666666,
      house: 0.5066766666666667,
      soc: 56.6654,
      solar: 0.0,
      timestamp: "2025-03-26T22:30:00+11:00",
    },
    {
      battery: 0.5115833333333333,
      ev: 0.0,
      grid: 0.01033,
      house: 0.5219133333333333,
      soc: 56.3827,
      solar: 0.0,
      timestamp: "2025-03-26T22:35:00+11:00",
    },
    {
      battery: 0.49707999999999997,
      ev: 0.0,
      grid: 0.0021166666666666664,
      house: 0.49919666666666673,
      soc: 56.1082,
      solar: 0.0,
      timestamp: "2025-03-26T22:40:00+11:00",
    },
    {
      battery: 0.48308666666666666,
      ev: 0.0,
      grid: 0.0036333333333333335,
      house: 0.48672,
      soc: 55.8407,
      solar: 0.0,
      timestamp: "2025-03-26T22:45:00+11:00",
    },
    {
      battery: 0.5217033333333334,
      ev: 0.0,
      grid: 0.00581,
      house: 0.5275133333333334,
      soc: 55.5517,
      solar: 0.0,
      timestamp: "2025-03-26T22:50:00+11:00",
    },
    {
      battery: 0.3907233333333333,
      ev: 0.0,
      grid: 0.003033333333333333,
      house: 0.39375666666666664,
      soc: 55.3356,
      solar: 0.0,
      timestamp: "2025-03-26T22:55:00+11:00",
    },
    {
      battery: 0.09969666666666668,
      ev: 0.0,
      grid: 0.4113866666666667,
      house: 0.5110833333333333,
      soc: 55.2798,
      solar: 0.0,
      timestamp: "2025-03-26T23:00:00+11:00",
    },
    {
      battery: 0.4119666666666667,
      ev: 0.0,
      grid: 0.10919333333333334,
      house: 0.5211600000000001,
      soc: 55.053,
      solar: 0.0,
      timestamp: "2025-03-26T23:05:00+11:00",
    },
    {
      battery: 0.6738366666666666,
      ev: 0.0,
      grid: 0.00792,
      house: 0.6817566666666667,
      soc: 54.6813,
      solar: 0.0,
      timestamp: "2025-03-26T23:10:00+11:00",
    },
    {
      battery: 0.6686966666666667,
      ev: 0.0,
      grid: 0.007526666666666668,
      house: 0.6762233333333334,
      soc: 54.3108,
      solar: 0.0,
      timestamp: "2025-03-26T23:15:00+11:00",
    },
    {
      battery: 0.6348866666666667,
      ev: 0.0,
      grid: 0.0013166666666666667,
      house: 0.6362033333333333,
      soc: 53.9595,
      solar: 0.0,
      timestamp: "2025-03-26T23:20:00+11:00",
    },
    {
      battery: 0.41374999999999995,
      ev: 0.0,
      grid: -0.0032700000000000003,
      house: 0.41048000000000007,
      soc: 53.7302,
      solar: 0.0,
      timestamp: "2025-03-26T23:25:00+11:00",
    },
    {
      battery: 0.25286,
      ev: 0.0,
      grid: 0.007209999999999999,
      house: 0.26007,
      soc: 53.5909,
      solar: 0.0,
      timestamp: "2025-03-26T23:30:00+11:00",
    },
    {
      battery: 0.33657,
      ev: 0.0,
      grid: 0.0026433333333333335,
      house: 0.3392133333333333,
      soc: 53.405,
      solar: 0.0,
      timestamp: "2025-03-26T23:35:00+11:00",
    },
    {
      battery: 0.33122,
      ev: 0.0,
      grid: 0.0023666666666666667,
      house: 0.3335866666666667,
      soc: 53.2225,
      solar: 0.0,
      timestamp: "2025-03-26T23:40:00+11:00",
    },
    {
      battery: 0.29610333333333333,
      ev: 0.0,
      grid: 0.003853333333333333,
      house: 0.29995666666666665,
      soc: 53.0588,
      solar: 0.0,
      timestamp: "2025-03-26T23:45:00+11:00",
    },
    {
      battery: 0.22549666666666668,
      ev: 0.0,
      grid: 0.00262,
      house: 0.2281166666666667,
      soc: 52.9342,
      solar: 0.0,
      timestamp: "2025-03-26T23:50:00+11:00",
    },
    {
      battery: 0.2993033333333333,
      ev: 0.0,
      grid: 0.00648,
      house: 0.30578333333333335,
      soc: 52.7692,
      solar: 0.0,
      timestamp: "2025-03-26T23:55:00+11:00",
    },
  ];
};
